import { __module as t } from "../../../_virtual/isAfter.js";
import { a as e } from "./util/assertString.js";
import { t as r } from "./toDate.js";
!function (t, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = function (t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : String(new Date());
    (0, o.default)(t);
    var r = (0, u.default)(e),
      a = (0, u.default)(t);
    return !!(a && r && a > r);
  };
  var o = s(e),
    u = s(r);
  function s(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  t.exports = a.default, t.exports.default = a.default;
}(t, t.exports);
var a = t.exports;
export { a as i };